<template>
    <Dropdown
        @click="isOpen = !isOpen"
        :show="isOpen"
    >
        <template #content>
            <span class="hidden md:block text-gray-700">
                {{ customer.getFullName() }}
            </span>
            <Image
                class="rounded-full w-8 h-8 object-cover"
                :src="customer.getProfilePictureUrlWithFallback()"
            />
        </template>
        <template #items>
            <DropdownItem @click="callback()">Logout</DropdownItem>
        </template>
    </Dropdown>
</template>

<script setup lang="ts">
    import { ref } from 'vue'
    import Dropdown from '@/Shared/Component/Dropdown.vue'
    import DropdownItem from '@/Shared/Component/DropdownItem.vue'
    import Customer from '@/App/Customer/Entity/Customer'
    import Image from '@/Shared/Component/Image.vue'

    interface BaseCustomerProfileDropdownProps {
        callback: () => void
        customer: Customer
    }

    const props = defineProps<BaseCustomerProfileDropdownProps>()
    const isOpen = ref<boolean>(false)
</script>
